import React from "react";
import styled from "styled-components";
import Button from "../../ui/components/Button";

const ButtonContainer = styled.div`
    position: relative;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    width: fit-content;
    gap: 10px;
    z-index: 2;
`;

const RainbowGlow = styled.div`
    position: absolute;
    height: 12px;
    width: 80%;
    border-radius: 50%;
    background: linear-gradient(90deg, red, orange, yellow, lime, green, cyan, blue, violet, purple, hotpink, red);
    background-size: 600% 100%;
    pointer-events: none;
    z-index: 1;
    
    animation: rainbow-glow 60s linear infinite;

    @keyframes rainbow-glow {
        0% {
            background-position: 0% 50%;
        }
        100% {
            background-position: -600% 50%;
        }
    }
`;

const RainbowGlowTop = styled(RainbowGlow)`
    top: -2px;
    height: 4px;
    filter: blur(2px);
`;

const RainbowGlowBottom = styled(RainbowGlow)`
    bottom: -8px;
    height: 12px;
    filter: blur(4px);
`;

interface RainbowButtonProps {
    onClick: () => void;
    color?: 'white' | 'black';
    text: string;
}

const RainbowButton = ({ onClick, color = 'white', text }: RainbowButtonProps) => {
    return (
        <ButtonContainer>
            <RainbowGlowTop />
            <RainbowGlowBottom />
            <Button size="large" color={color} text={text} onClick={onClick} />
        </ButtonContainer>
    )
};

export default RainbowButton;